/* =========================================
   FEES PAGE ANIMATIONS
   ========================================= */
document.addEventListener('DOMContentLoaded', () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);
    let mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {

    // FEES PAGE WATERFALL
    if (document.querySelector('.fees-header')) {
        const feesTl = gsap.timeline({ defaults: { ease: 'power3.out', duration: 0.8 } });
        
        feesTl.fromTo('.fees-header h1', 
            { opacity: 0, y: 30 }, 
            { opacity: 1, y: 0, delay: 0.1 }
        )
        .fromTo('.fees-header p', 
            { opacity: 0, y: 20 }, 
            { opacity: 1, y: 0 }, 
            "-=0.6"
        )
        .fromTo('.table-container', 
            { opacity: 0, y: 40 }, 
            { opacity: 1, y: 0 }, 
            "-=0.6"
        )
        .fromTo('.fees-table tbody tr', 
            { opacity: 0, x: -20 }, 
            { opacity: 1, x: 0, stagger: 0.1 }, 
            "-=0.4"
        )
        .fromTo('.all-inclusive-banner', 
            { opacity: 0, y: 30 }, 
            { opacity: 1, y: 0 }, 
            "-=0.6"
        );
    }

    // Funding Cards
    if (document.querySelector('.funding-grid')) {
        gsap.timeline({
            scrollTrigger: { trigger: '.funding-grid', start: 'top 85%' }
        }).fromTo('.funding-card',
            { opacity: 0, y: 30 },
            { opacity: 1, y: 0, duration: 0.8, stagger: 0.15, ease: 'power3.out' }
        );
    }

    // Policy Cards
    if (document.querySelector('.policies-grid')) {
        // Unhide the headers/content (which are hidden globally in style.css for FOUC prevention)
        // so they can fade in naturally with the parent card.
        gsap.set('.policy-card .policy-header, .policy-card .policy-content', { opacity: 1 });
        
        gsap.timeline({
            scrollTrigger: { trigger: '.policies-grid', start: 'top 85%' }
        }).fromTo('.policy-card',
            { opacity: 0, y: 30 },
            { opacity: 1, y: 0, duration: 0.6, stagger: 0.1, ease: 'power3.out' }
        );
    }

    // Dual CTA Boxes
    if (document.querySelector('.dual-cta-grid')) {
        gsap.timeline({
            scrollTrigger: { trigger: '.dual-cta-grid', start: 'top 85%' }
        }).fromTo('.cta-box',
            { opacity: 0, y: 30 },
            { opacity: 1, y: 0, duration: 0.8, stagger: 0.15, ease: 'power3.out' }
        );
    }

    // FAQ List Items
    if (document.querySelector('.faq-list')) {
        gsap.timeline({
            scrollTrigger: { trigger: '.faq-list', start: 'top 85%' }
        }).fromTo('.faq-list li',
            { opacity: 0, x: -20 },
            { opacity: 1, x: 0, duration: 0.6, stagger: 0.1, ease: 'power2.out' }
        );
    }
    }); // End matchMedia
});
